import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs/operators';
import {AppStore} from '../store/app.store';
import {ResultsStore} from '../store/results.store';
import {tap} from 'rxjs';
import {NavigationService} from '../services/navigation.service';
import {PostHogService} from '../services/posthog.service';

export const initGuard: CanActivateFn = (route) => {
  const appStore = inject(AppStore);
  const resultsStore = inject(ResultsStore);
  const postHogService = inject(PostHogService);
  const navigation = inject(NavigationService);

  // Already initialized
  if (appStore.cart().id) {
    return true;
  }

  // Has error
  if (appStore.cartError()) {
    return false;
  }

  // Get params from route
  const session_id = route.paramMap.get('session_id');

  if (!session_id) {
    return false;
  }

  appStore.initialize({session_id});

  // Wait for initialization to complete
  return toObservable(appStore.cart).pipe(
    filter(cart => !!cart.id),
    tap(cart => {
      document.documentElement.classList.remove(`theme-default`);
      document.documentElement.classList.add(`theme-${appStore.getSetting()('theme').value}`);
      const { location } = appStore;
      postHogService.posthog.identify(appStore.client_id(), {
        location_name: location().name,
        location_phone: location().phone,
        location_city: location().city,
        location_state: location().state,
      });

      if (cart.snapshot) {
        navigation.navigate('compare')
      } else {
        navigation.navigate('lookup')
      }
    }),
    map(() => true),
    take(1)
  );
};
